// test2504
(2504 && 0);
